// Main Menu
import { getElement, getElements, ifSelectorExist, off } from './utils';

// mobile menu
export const mobileMenu = () => {
  const mobileMenuWrapperSelector = getElement('.mobile__menu_wrapper');
  if (ifSelectorExist(mobileMenuWrapperSelector)) {
    const menuOverlay = getElement('.close_menu_overlay');
    const openMenu = () => {
      mobileMenuWrapperSelector.classList.add('menu-opened');
      menuOverlay.classList.remove('hidden')
    }

    const closeMenu = () => {
      mobileMenuWrapperSelector.classList.remove('menu-opened');
      menuOverlay.classList.add('hidden')
    }

    getElement('.menu_toggler').addEventListener('click', () => {
      openMenu();
      menuOverlay.classList.remove('hidden')
    })

    getElement('.close_menu').addEventListener('click', () => {
      closeMenu();
      menuOverlay.classList.add('hidden')
    })

    menuOverlay.addEventListener('click', () => {
      closeMenu();
      menuOverlay.classList.add('hidden')
    })

  }
}